import { jsx } from "react/jsx-runtime";
import { ThemeProvider } from "@mui/material";
import { createTheme } from "../../../constants/create-theme/create-theme.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { typography, MuiTypography } from "../../../themes/typography/typography.js";
import { MuiButton } from "../../../themes/button/button.js";
import "color-alpha";
import "../../../themes/external-theme/external-theme.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/shadows/shadows.js";
import { AxiosProvider } from "./components/AxiosProvider/index.js";
import { CallTasksProvider } from "./components/CallTasksProvider/index.js";
import { TimerProvider } from "./components/TimerProvider/index.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
import "react";
import "axios";
import "./call-management.types.js";
import "./helpers/prioritizeCalls.js";
import "date-fns";
import "./helpers/updateElement.js";
import "./hooks/useCallTasks.js";
import "./call-management.constants.js";
import "./helpers/withQueryParams.js";
import "./hooks/useServerSentEvents.js";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
const theme = createTheme({
  typography,
  components: {
    MuiTypography,
    MuiButton
  }
});
const withCallManagementProviders = (Component) => (props) => {
  const axiosProviderProps = {
    ...props,
    auth: props.auth ?? ""
  };
  return /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(AxiosProvider, { ...axiosProviderProps, children: /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children: /* @__PURE__ */ jsx(CallTasksProvider, { ...props, children: /* @__PURE__ */ jsx(TimerProvider, { children: /* @__PURE__ */ jsx(Component, { ...props }) }) }) }) }) });
};
export {
  withCallManagementProviders
};
